import { render } from "./BaseImg.vue?vue&type=template&id=0adbbaee&scoped=true"
import script from "./BaseImg.vue?vue&type=script&lang=js"
export * from "./BaseImg.vue?vue&type=script&lang=js"

import "./BaseImg.vue?vue&type=style&index=0&id=0adbbaee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0adbbaee"

export default script